import React, { Component } from "react";
import { connect } from "react-redux";
import { withRouter, browserHistory } from "react-router";
import { JobList } from "./JobList";
import { JobSearchForm } from "./elements";
import * as basketActions from "../../../../../actions/transactions/basket";
import * as purchaseActions from "../../../../../actions/transactions/purchases";
import * as cvActions from "../../../../../actions/cvservice/cvservice";
import { Pagination, Loader } from "../../../../common/elements";
import { NoResults } from "../../../../common/elements/NoResults";
import { PaginationHelpers as Page, genericHelpers, requestHelpers } from "../../../../../helpers/";
import * as jobsActions from "../../../../../actions/jobs/jobs";
import * as commonActionsSearch from "../../../../../actions/common/search";
import * as accountActions from "../../../../../actions/account/account";
import { addSlotsToJobs } from "../../../../common/adverts/googleDFP/lib/helpers";
import { ReactDFPWrapper } from "../../../../common/adverts/googleDFP/ReactDFPWrapper";
import Anchor from "../../../../dashboardNew/objects/Anchor";
import { PrismicDocumentHelper } from "../../../../../helpers/prismicHelpers/PrismicHelpers";
import { jobsPageHelper } from "../../../../../helpers/prismicHelpers/prismic-custom-helpers/JobsPageHelper";

class JobsPage extends Component {
    constructor(props) {
        super(props);
        this.showToolHelper = this.showToolHelper.bind(this)
        this.state = {
            preferences: false,
            okLocation: true,
            notSeenPopup: false,
            toolShow: false,
            jobsInfo: '',
            cvInterestSent : false,
            disableCvIntegrateButton : false
        };
    }

    showToolHelper() {
        this.setState({
            toolShow: !this.state.toolShow
        });
    }

    componentWillMount() {
        this.getJobsInfoPrismic();
        this.props.getJobs(this.props.location.query.page || 1, this.getJobOpts(this.props.options));
        this.props.getProducts();
        this.props.getLocations();
        this.props.getExpertise();
        this.props.getIndustries();
        this.props.getRemunerationTypes();
        this.props.getSectors();
        this.props.setAccount(localStorage.getItem('person_id'));
    }

    componentWillUnmount() {
        this.props.unmountJobs();
        this.state.notSeenPopup === null && this.unregisterLeaveHook();
    }

    async getJobsInfoPrismic() {
        const data = await PrismicDocumentHelper('document.type', 'jobs-page', false, 'at')
        const jobsInfo = jobsPageHelper(data);
        this.setState({ jobsInfo })
        window.scrollTo(0, 0);
    }

    getJobOpts(opts) {
        let country_id = genericHelpers.countryAbbrToCode(genericHelpers.siteOfOriginHelper());
        if (opts) {
            opts.country_id = isNaN(Number(opts.country_id)) ? (opts.country_id ? opts.country_id.value : country_id) : opts.country_id;
        };
        return !opts ? { country_id } : { country_id, ...opts };
    }

    handleGoToPromo(path) {
        const curtain = document.getElementsByClassName('theme-curtain');
        const personId = localStorage.getItem("person_id");
        cvActions.postCVInterest(personId);
        curtain[0].classList.add('active');
        setTimeout(() => {
            browserHistory.push(path);
            window.scrollTo(0, 0);
        }, 500);
        setTimeout(() => {
            curtain[0].classList.remove('active');
        }, 1000);
    };

    clearSearchForm(ev) {
        ev.preventDefault();

        if (this.props.formValues.values) {
            this.props.formValues.values = null;
            this.props.formValues.initial = null;
        };

        const page = this.props.location.query.page || 1;
        browserHistory.push(`/jobs?page=${page}`);
        this.props.getJobs(page, null);
    };

    jobSearch(options) {
        const page = 1;
        const personId = localStorage.getItem('person_id');

        browserHistory.push(`/jobs?page=${page}`);
        this.props.saveSearch(personId, options, false);
        this.props.getJobs(page, this.getJobOpts(options));
    };

    getNextJobs(pageId) {
        this.props.getJobs(pageId, this.getJobOpts(this.props.options));
        browserHistory.push(`jobs?page=${pageId}`);
    };

    addJobToFavourites = (jobId, index) => {
        this.props.addJobToFavourites( localStorage.getItem( 'person_id' ), jobId, index, false );
    };

    removeJobFromFavourites = (jobId, index) => {
        this.props.removeJobFromFavourites( localStorage.getItem( "person_id" ), jobId, index, false );
    };

    pagination() {
        const totalPages = this.props.paging && this.props.paging.total_pages;
        const currentPage = Page.setCurrentPage( this.props.location.query.page, totalPages );
        const pagination_details = Page.getCurrentPage( currentPage, totalPages );
        const pageNumbers = Page.getPageNumbers( pagination_details );

        if( !totalPages || totalPages < 2 ){ return };
        return (
            <Pagination
                currentPage={currentPage}
                pagination={pagination_details}
                pageNumbers={pageNumbers}
                totalPages={totalPages}
                onPaginationClick={currentPage => this.getNextJobs(currentPage)}/>
        );
    }

    JobSearchForm() {
        return (
            <JobSearchForm
                onSubmit={options => this.jobSearch(options)}
                data={this.props.jobs}
                locations={this.props.locations}
                advanced={(({ industries, expertise, sectors }) => ({
                    industries: industries || [],
                    expertise: expertise || [],
                    sectors: sectors || []
                }))(this.props)}
                clearForm={ev => this.clearSearchForm(ev)}
                jobsInfo={this.state.jobsInfo[0]}
            />
        );
    }

    JobList() {
        return (
            <JobList
                addJobToFavourites={(jobId, index) => this.addJobToFavourites(jobId, index)}
                removeJobFromFavourites={(jobId, index) => this.removeJobFromFavourites(jobId, index)}
                jobs={this.props.jobs.length > 0 && this.props.jobs !== 'load' ? addSlotsToJobs(this.props.jobs, 4) : this.props.jobs}
                industries={this.props.industries}
                locations={this.props.locations} />
        );
    }

    content() {
        if (this.props.jobs === 'load') {
            return <Loader />;
        } else {
            return this.props.jobs instanceof Array && this.props.jobs.length === 0 ? <NoResults /> : this.JobList();
        };
    }

    cvInterestClicked = () => {
        this.setState({ disableCvIntegrateButton : true });
        requestHelpers
            .authenticatedPostRequest( '/communications/enquire-writing-services', { person_id : window.localStorage.getItem( 'person_id' ), page : 'JobsPage' } )
            .then( res => this.setState({ cvInterestSent : true }, () => setTimeout( () => this.state.toolShow && this.showToolHelper(), 5000 )) )
            .catch( err => this.setState({ disableCvIntegrateButton : false }, () => console.error( 'err : ', err ) ));

    }

    render() {
        const job = this.state.jobsInfo[0] && this.state.jobsInfo[0];
        return (
            <ReactDFPWrapper adUnit='PTL.NED/JOBS.BRD'>
                <article
                    className={`theme-page-content-wrapper article-wrapper ${this.state.toolShow ? "tool-show" : ""}`}>
                    {job && <div className="theme-tool-wrapper">
                        <span className="heading-main">{job.promo_title}</span>
                        <p className='body-copy'>{job.promo_summary}</p>
                        { this.state.cvInterestSent && <p className="body-copy lead-message">Thank you for your enquiry. Someone from our CV services team will be in touch.</p> }
                        <button className={ `theme-button${ this.state.disableCvIntegrateButton ? ' disabled' : '' }` } onClick={ this.cvInterestClicked }>{job.button_text}</button>
                    </div>}
                    <div className="container tool-container">
                        <button
                            type="button"
                            className="theme-tool-toggle"
                            onClick={this.showToolHelper}
                        >
                            <img src="/images/icons-new/arrow-down.svg" alt="business man icon" className="toggle-icon" />
                            <img src="/images/icons-new/close.svg" alt="business man icon"
                                className="toggle-icon state-open" />
                        </button>
                    </div>
                    {this.JobSearchForm()}
                    <main className="main--jobs">
                        <div className="container">
                            <div className="row">
                                <div className="col-12 heading-section body-copy">
                                    <p className='body-copy'>{job && job.job_summary}
                                        {job && <Anchor internal path={job.job_summary_path}
                                            anchorClass={'clickable'}>
                                            {job.job_summary_label}
                                        </Anchor>
                                        }
                                    </p>
                                </div>
                                <div className="col-12">
                                    { this.content() }
                                    { this.pagination() }
                                </div>
                            </div>
                        </div>
                    </main>
                </article>
            </ReactDFPWrapper>
        );
    }
}

const mapStateToProps = state => ({
    jobs                : state.jobs.jobs,
    paging              : state.jobs.pagination,
    originalProducts    : state.transactions.products,
    locations           : state.search.locations,
    expertise           : state.search.expertise,
    industries          : state.search.industries,
    remuneration_types  : state.search.remuneration_types,
    sectors             : state.search.sectors,
    options             : state.jobs.options,
    formValues          : state.form.job_search_form,
    account             : state.account.account
});

const mapDispatchToProps = dispatch => ({
	getJobs					: ( page, options ) => dispatch( jobsActions.getJobs( page, options ) ),
	addProductToBasket		: productId => dispatch( basketActions.addProductToBasket( productId ) ),
	getProducts				: () => dispatch( purchaseActions.getProducts() ),
	getLocations			: () => dispatch( commonActionsSearch.getLocations() ),
	getExpertise			: () => dispatch( commonActionsSearch.getExpertise() ),
	getIndustries			: () => dispatch( commonActionsSearch.getIndustries() ),
	getRemunerationTypes	: () => dispatch( commonActionsSearch.getRemunerationTypes() ),
	getSectors				: () => dispatch( commonActionsSearch.getSectors() ),
	unmountJobs				: () => dispatch( jobsActions.unmountJobs() ),
	addJobToFavourites		: ( personId, jobId, index, skip ) => dispatch( jobsActions.addJobToFavourites( personId, jobId, index, skip ) ),
	removeJobFromFavourites	: ( personId, jobId, index, skip ) => dispatch( jobsActions.removeJobFromFavourites( personId, jobId, index, skip ) ),
	saveSearch				: ( personId, searchValues, flag ) => dispatch( jobsActions.saveSearch( personId, searchValues, flag ) ),
	setAccount				: personId => dispatch( accountActions.setAccount( personId ) )
});

export default withRouter( connect( mapStateToProps, mapDispatchToProps )( JobsPage ) );



// WEBPACK FOOTER //
// src/client/components/site/features/jobs/pages/JobsPage.js